const localStorageMethods = {
    getItemFromLocalStorage: (key: string) => {
      try {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : null;
      } catch (error) {
        console.error("Error retrieving item from localStorage:", error);
        return null;
      }
    },
    setItemInLocalStorage: (key: string, value: unknown) => {
      try {
        const serializedValue = JSON.stringify(value);
        localStorage.setItem(key, serializedValue);
      } catch (error) {
        console.error("Error setting item in localStorage:", error);
      }
    },
    removeItemFromLocalStorage: (key: string) => {
      try {
        localStorage.removeItem(key);
      } catch (error) {
        console.error("Error removing item from localStorage:", error);
      }
    },
    emptyLocalStorage: () => {
      try {
        localStorage.clear();
      } catch (error) {
        console.error("Error clearing all items from localStorage:", error);
      }
    },
  };
  
  export default localStorageMethods;
  